import script from "./AbaMenuConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AbaMenuConfig.vue?vue&type=script&setup=true&lang=js"

import "./AbaMenuConfig.vue?vue&type=style&index=0&id=59e7db1c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e7db1c"]])

export default __exports__